import { useTranslation } from 'react-i18next';
import Header from '../components/feature/Header';
import Footer from '../components/feature/Footer';

const COUNTRY_ROWS = ['austria', 'czechia', 'slovakia', 'hungary', 'slovenia', 'switzerland', 'romania', 'bulgaria'];

export default function BlogPricesPage() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 bg-bg">
        <div className="mx-auto max-w-3xl px-5 py-14">
          <span className="inline-flex rounded-full bg-primary-soft px-3 py-1 text-[12px] font-medium text-primary">{t('blog.post7.category')}</span>
          <h1 className="mt-3 text-[26px] font-bold tracking-tight">{t('blog.post7.title')}</h1>
          <p className="mt-2 text-[14px] text-muted">{t('blog.post7.readTime')}</p>
          <div className="mt-8 space-y-5 text-[15px] leading-relaxed text-ink-soft">
            <p>{t('blog.post7.body.p1')}</p>

            <div className="overflow-x-auto mt-4">
              <table className="w-full text-left text-[14px] border-collapse">
                <thead>
                  <tr className="border-b border-border">
                    <th className="py-2.5 pr-4 font-semibold">{t('blog.post7.body.table.head.country')}</th>
                    <th className="py-2.5 pr-4 font-semibold">{t('blog.post7.body.table.head.short')}</th>
                    <th className="py-2.5 pr-4 font-semibold">{t('blog.post7.body.table.head.medium')}</th>
                    <th className="py-2.5 font-semibold">{t('blog.post7.body.table.head.annual')}</th>
                  </tr>
                </thead>
                <tbody>
                  {COUNTRY_ROWS.map((c, i) => (
                    <tr key={c} className={i < COUNTRY_ROWS.length - 1 ? 'border-b border-border' : ''}>
                      <td className="py-2.5 pr-4 font-medium">{t(`blog.post7.body.table.${c}.name`)}</td>
                      <td className="py-2.5 pr-4">{t(`blog.post7.body.table.${c}.short`)}</td>
                      <td className="py-2.5 pr-4">{t(`blog.post7.body.table.${c}.medium`)}</td>
                      <td className="py-2.5">{t(`blog.post7.body.table.${c}.annual`)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <h3 className="text-[18px] font-semibold text-ink mt-6">{t('blog.post7.body.h1')}</h3>
            <p>{t('blog.post7.body.p2')}</p>

            <h3 className="text-[18px] font-semibold text-ink mt-6">{t('blog.post7.body.h2')}</h3>
            <p>{t('blog.post7.body.p3')}</p>

            <h3 className="text-[18px] font-semibold text-ink mt-6">{t('blog.post7.body.h3')}</h3>
            <p>{t('blog.post7.body.p4')}</p>

            <h3 className="text-[18px] font-semibold text-ink mt-6">{t('blog.post7.body.h4')}</h3>
            <p>{t('blog.post7.body.p5')}</p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
